// The line preferences of the user are kept per space (the lines are the ones of the plant): the key of the
// preference is the name followed by the id of the space, e.g. `user.lines.preferred.lowpower-ipn`
const preferredLinesKey = (spaceId: string): string => `user.lines.preferred.${spaceId}`
const defaultLineKey = (spaceId: string): string => `user.lines.default.${spaceId}`

export { preferredLinesKey, defaultLineKey }
